import React from 'react';
import { FaCalendarAlt, FaHistory } from 'react-icons/fa';
import CompromisoPagoFormModal from '../../../components/ui/GestionMorasComponents/CompromisoPagoFormModal';
import {
  formatearFecha,
  formatearFechaHora,
  formatearMoneda,
  obtenerFechaActualISO
} from '../../../utilities/gestionMorasUtils';

export default function CompromisoPagoModal({
  isOpen,
  mode,
  prestamo,
  compromiso,
  formData,
  errors,
  saving,
  onClose,
  onChange,
  onSubmit
}) {
  const isEditMode = mode === 'edit';

  const highlight = isEditMode && compromiso ? (
    <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-amber-700">Registro actual</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-700">
          <FaCalendarAlt className="h-3.5 w-3.5 text-amber-600" />
          Compromiso: {formatearFecha(compromiso.fecha_compromiso)}
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-700">
          Monto: {formatearMoneda(compromiso.monto_compromiso)}
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-700">
          <FaHistory className="h-3.5 w-3.5 text-amber-600" />
          Registrado: {formatearFechaHora(compromiso.created_at)}
        </span>
      </div>
    </div>
  ) : prestamo?.ultimo_compromiso_pago ? (
    <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-amber-700">Último compromiso</p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <p className="text-sm font-semibold text-slate-900">
          {formatearFecha(prestamo.ultimo_compromiso_pago.fecha_compromiso)}
        </p>
        <span className="inline-flex items-center rounded-full bg-white px-3 py-1 text-xs font-semibold text-slate-900">
          {formatearMoneda(prestamo.ultimo_compromiso_pago.monto_compromiso)}
        </span>
      </div>
      <p className="mt-1 text-sm leading-6 text-slate-600">{prestamo.ultimo_compromiso_pago.motivo}</p>
    </div>
  ) : null;

  return (
    <CompromisoPagoFormModal
      isOpen={isOpen}
      dialogId="admin-compromiso-pago-title"
      eyebrow={isEditMode ? null : 'Gestión de moras admin'}
      title={isEditMode ? 'Editar compromiso de pago' : 'Registrar compromiso de pago'}
      prestamo={prestamo}
      summary={
        <>
          <p className="modal-text mt-2">
            Cliente: <span className="font-semibold text-slate-900">{prestamo?.cliente}</span>
          </p>
          <p className="modal-text">
            Crédito #{prestamo?.numero_credito} | Asesor: {prestamo?.asesor_nombre || 'Sin asesor'}
          </p>
        </>
      }
      highlight={highlight}
      formData={formData}
      errors={errors}
      saving={saving}
      onClose={onClose}
      onChange={onChange}
      onSubmit={onSubmit}
      minFechaCompromiso={!isEditMode ? obtenerFechaActualISO() : undefined}
      submitLabel={isEditMode ? 'Actualizar compromiso' : 'Guardar compromiso'}
      savingLabel={isEditMode ? 'Actualizando...' : 'Guardando...'}
    />
  );
}